export class EngineResult{
    controlProperties: any = {};
}